import { Select } from "antd";
import { I18N_NS } from "Config/i18n";
import { withTranslation, WithTranslation } from "react-i18next";

interface QATypeSelectProps extends WithTranslation {
  onChange: (val: boolean) => void;
  isPrivate: boolean;
}

export const QATypeSelect = withTranslation(I18N_NS.PROJECT)(({ onChange, isPrivate, t }: QATypeSelectProps) => {
  const changeType = (value: string) => {
    onChange(value === "true");
  };

  return (
    <Select style={{ minWidth: 150 }} onSelect={changeType} value={`${isPrivate}`}>
      <Select.Option key={`1`} value={"true"}>
        {t("Private")}
      </Select.Option>
      <Select.Option key={`2`} value={"false"}>
        {t("Public")}
      </Select.Option>
    </Select>
  );
});
